// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"12":"3228698149df4c833d0b","777":"1f0fdde98c7225c0e910"}[chunkId] + ".js";
};